import { httpRequest } from "@services/http";

export class CommandDeletePopulationSegment {
  // Backend returns a JSON-encoded confirmation string; a 409 (in use) surfaces as a thrown Error.
  async run(organizationId: number, segmentId: number): Promise<string> {
    const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/organizations/${organizationId}/segments/${segmentId}/`;
    return await httpRequest<string>(url, { method: "DELETE" });
  }
}
